export const MAX_PRODUCTS_IN_HIGHLIGHT = 10;
export const ASPECT_RATION_LANDSCAPE = 4 / 3;
export const ASPECT_RATIO_PORTRAIT = 3 / 4;
export const IMAGE_QUALITY = 1;
export const MAX_VARIANTS_PER_PAGE_IN_OPTION = 7;
export const MAX_COUNT_BANNER_TITLE = 70;
